export default "__VITE_ASSET__CYRnwu8C__"